const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 398.851,
    y: 174.74,
    transform: "matrix(0.704 -0.7102 0.7102 0.704 -42.2075 363.9888)",
    style: {
      fill: "#D7D7D7"
    },
    width: 33.417,
    height: 115.779
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B0B0"
    },
    d: "M466.776,328.709l5.13-33.022c-0.903-0.14-2.228-0.555-3.405-1.732c-2.41-2.41-2.412-6.335,0-8.745 c2.412-2.41,6.335-2.412,8.746,0c1.177,1.177,1.592,2.502,1.732,3.405L512,283.487c-1.298-8.351-5.144-15.925-11.123-21.905 c-15.44-15.44-40.564-15.441-56.005,0s-15.44,40.565,0,56.005C450.852,323.566,458.426,327.412,466.776,328.709z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.733,
    y: 174.756,
    transform: "matrix(-0.704 -0.7102 0.7102 -0.704 -0.8879 464.9204)",
    style: {
      fill: "#ECECED"
    },
    width: 33.417,
    height: 115.779
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E5EA"
    },
    d: "M360.457,182.403H151.542v-61.667c0-57.594,46.86-104.451,104.457-104.451 s104.457,46.856,104.457,104.451L360.457,182.403L360.457,182.403z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#79BBBC"
    },
    d: "M360.457,182.403H255.999c0,0,0-143.614,0-166.119c57.598,0,104.457,46.856,104.457,104.451V182.403z "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.836,
    y: 165.694,
    style: {
      fill: "#D7D7D7"
    },
    width: 270.333,
    height: 253.625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.997,
    y: 165.694,
    style: {
      fill: "#B0B0B0"
    },
    width: 135.161,
    height: 253.625
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8F9FA"
    },
    d: "M255.999,130.196c-17.012,0-30.853-13.84-30.853-30.852s13.84-30.852,30.853-30.852 c17.013,0,30.853,13.84,30.853,30.852S273.012,130.196,255.999,130.196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E5EA"
    },
    d: "M255.999,130.196V68.493c17.012,0,30.853,13.84,30.853,30.852S273.012,130.196,255.999,130.196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8F9FA"
    },
    d: "M334.663,309.217H177.337V218.35h157.327L334.663,309.217L334.663,309.217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E5EA"
    },
    d: "M334.663,309.217h-78.664V218.35h78.664V309.217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8B8B8B"
    },
    d: "M189.799,495.715H85.288V322.484h104.511L189.799,495.715L189.799,495.715z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 85.292,
    y: 358.065,
    style: {
      fill: "#6F6F6F"
    },
    width: 104.506,
    height: 33.417
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.292,
    y: 426.781,
    style: {
      fill: "#6F6F6F"
    },
    width: 104.506,
    height: 33.417
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6F6F6F"
    },
    d: "M322.2,322.484h104.511v173.231H322.2V322.484z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 322.197,
    y: 358.065,
    style: {
      fill: "#444444"
    },
    width: 104.506,
    height: 33.417
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.197,
    y: 426.781,
    style: {
      fill: "#444444"
    },
    width: 104.506,
    height: 33.417
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7D7D7"
    },
    d: "M45.224,328.709l-5.13-33.022c0.903-0.14,2.228-0.555,3.405-1.732c2.41-2.41,2.412-6.335,0-8.745 s-6.335-2.412-8.746,0c-1.177,1.177-1.592,2.502-1.732,3.405L0,283.487c1.298-8.351,5.144-15.925,11.123-21.905 c15.44-15.44,40.564-15.441,56.005,0s15.44,40.565,0,56.005C61.148,323.566,53.573,327.412,45.224,328.709z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.08a879814d4ac31798979bdf2f0b3271.svg";
export { ForwardRef as ReactComponent };